import moment from 'moment'

/**
 * Formats the input date with the provided pattern
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  return date ? moment(date).local(true).format(format) : ''
}

/**
 * Formats the input date with the provided pattern regardless of the timezone
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
export const formatDateUTC = (date, format = 'DD/MM/YYYY HH:mm') => {
  return date ? moment(date).utc().format(format) : ''
}

/**
 * Formats the input date relative to now
 * @param {string} date
 * @returns {string}
 */
export function formatRelativeTime(date) {
  return moment(date).fromNow()
}

/**
 * 1. If the given date is the same as today, the function returns the time
 * 2. If not, the 3 letter month name and day number will be returned
 * @param {string} dateTime
 * @returns {string}
 */
export const formatDateRelativeToToday = (dateTime) => {
  const currentDate = moment()
  const targetDate = moment(dateTime)
  if (currentDate.isSame(targetDate, 'day')) {
    return targetDate.format('HH:mm')
  } else {
    return targetDate.format('D MMM')
  }
}

/**
 * Checks if the given date is tomorrow
 * @param {string} dateTime
 * @returns {boolean}
 */
export const isTargetDateTomorrow = (dateTime) => {
  const currentDate = moment()
  const targetDate = moment(dateTime)
  const tomorrow = currentDate.add(1, 'day').startOf('day')

  return targetDate.isSame(tomorrow, 'day')
}

/**
 * Checks if the provided dateTimes are the same based on the given criteria
 * @param {string} dateTime1
 * @param {string} dateTime2
 * @param {string} criteria
 * @returns {boolean}
 */
export const isDateTimeSame = (dateTime1, dateTime2, criteria) => {
  const dt1 = moment(dateTime1)
  const dt2 = moment(dateTime2)

  return dt1.isSame(dt2, criteria)
}

/**
 * Checks if the given date is today
 * @param {string} dateTime
 * @returns {boolean}
 */
export const isTargetDateToday = (dateTime) => {
  const currentDate = moment()
  const targetDate = moment(dateTime)

  return targetDate.isSame(currentDate, 'day')
}

/**
 * Checks if the given date is less than the current date based on the provided amount and criteria
 * @param {string} dateTime
 * @param {number} amount
 * @param {string} criteria
 * @returns {boolean}
 */
export const isWithinTimeFrame = (dateTime, amount, criteria) => {
  const currentDate = moment()
  const targetDate = moment(dateTime)
  const dateDiff = targetDate.diff(currentDate, criteria)

  return dateDiff <= amount && dateDiff > 0
}

/**
 * Returns the difference between the target time and the current time based on the provided criteria
 * @param {string} dateTime
 * @param {string} criteria
 * @returns {number}
 */
export const getTimeDifference = (dateTime, criteria) => {
  const currentDate = moment()
  const targetDate = moment(dateTime)

  return targetDate.diff(currentDate, criteria)
}

/**
 * Adds the provided amount based on the given criteria to current date and return the dateTime string
 * @param {number} amount
 * @param {string} criteria
 * @returns {string}
 */
export const getDateTimeInFuture = (amount, criteria) => {
  const targetDate = moment().add(amount, criteria)

  return targetDate.format()
}
